/* Sail Workshop — kategori dairelerini oklarla kaydırır, uçlarda okları gizler. */
(function () {
  function init() {
    document.querySelectorAll('.cat-circles__viewport').forEach(function (viewport) {
      var track = viewport.querySelector('.cat-circles__track');
      var buttons = viewport.querySelectorAll('[data-circles-nav]');
      if (!track || !buttons.length) return;

      function sync() {
        var scrollable = track.scrollWidth > track.clientWidth + 4;
        buttons.forEach(function (btn) {
          if (!scrollable) { btn.hidden = true; return; }
          if (btn.dataset.circlesNav === 'prev') btn.hidden = track.scrollLeft <= 4;
          else btn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        });
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = track.clientWidth * 0.8;
          track.scrollBy({ left: btn.dataset.circlesNav === 'next' ? step : -step, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
